"use client";

import { ErrorFeedback } from "@/components/Error";
import { Container, Error404Illustration } from "@/screens/Error/styles";

import { useTranslations } from "next-intl";

export function NotFound() {
  const t = useTranslations("errors");

  return (
    <Container>
      <ErrorFeedback
        message={t("404.title")}
        details={t("404.description")}
        buttonText={t("404.action")}
        buttonLink="/"
        illustration={<Error404Illustration />}
        contactSupport={false}
        code="ERROR 404"
        codePosition="top"
      />
    </Container>
  );
}
